export const MODULE_NAME = 'home';
export const HOME_ROUTE = `/${MODULE_NAME}`;
